import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Settings, Target, DollarSign, Calendar } from 'lucide-react';

interface AdCampaignSectionProps {
  title: string;
  icon: 'settings' | 'targeting' | 'budget' | 'schedule';
  children: React.ReactNode;
  defaultExpanded?: boolean;
  badge?: string;
}

export default function AdCampaignSection({
  title,
  icon,
  children,
  defaultExpanded = true,
  badge
}: AdCampaignSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const getIcon = () => {
    const iconClass = "w-5 h-5";
    switch (icon) {
      case 'settings':
        return <Settings className={iconClass} />;
      case 'targeting':
        return <Target className={iconClass} />;
      case 'budget':
        return <DollarSign className={iconClass} />;
      case 'schedule':
        return <Calendar className={iconClass} />;
      default:
        return <Settings className={iconClass} />;
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm">
      {/* Section Header */}
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-colors flex items-center justify-between"
      >
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
            {getIcon()}
          </div>
          <span className="font-semibold text-gray-900">{title}</span>
          {badge && (
            <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
              {badge}
            </span>
          )}
        </div>
        <div className="text-gray-400">
          {isExpanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
        </div>
      </button>

      {/* Section Content */}
      {isExpanded && (
        <div className="p-4 space-y-6 border-t border-gray-100">
          {children}
        </div>
      )}
    </div>
  );
}